<div class="chat-popup">
    <!-- Glow Effect -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none rounded-[24px]">
        <div class="absolute top-0 left-1/4 w-64 h-64 bg-blue-400/10 rounded-full blur-3xl"></div>
        <div class="absolute bottom-0 right-1/4 w-48 h-48 bg-purple-400/10 rounded-full blur-3xl"></div>
    </div>

    <!-- Header -->
    <div class="chat-popup__header">
        <div class="chat-popup__header-info">
            <div class="chat-popup__title">
                {{ activeConversationTitle }}
            </div>
            <div class="chat-popup__subtitle">
                <span class="chat-popup__status-dot" [class.connecting]="loading"
                    [class.offline]="!connectionReady"></span>
                <span *ngIf="loading">{{ 'SystemAdmin.Components.Chat.Connecting' | translate }}</span>
                <span *ngIf="!loading && connectionReady">{{ 'SystemAdmin.Components.Chat.Online' | translate }}</span>
                <span *ngIf="!loading && !connectionReady">{{ 'SystemAdmin.Components.Chat.Offline' | translate
                    }}</span>
            </div>
        </div>
        <div class="chat-popup__header-actions">
            <button class="chat-popup__header-btn" [title]="'SystemAdmin.Components.Chat.Close' | translate"
                (click)="close()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6L6 18M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="chat-popup__content">
        <!-- Sidebar -->
        <aside class="chat-popup__sidebar">
            <div class="chat-popup__sidebar-header">
                <span class="chat-popup__sidebar-title">{{ 'SystemAdmin.Components.Chat.Conversations' | translate
                    }}</span>
                <button class="chat-popup__new-chat" [title]="'SystemAdmin.Components.Chat.NewChat' | translate"
                    (click)="openUserPicker()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 5v14M5 12h14" />
                    </svg>
                </button>
            </div>

            <div class="chat-popup__search">
                <input type="text" [(ngModel)]="listQuery"
                    [placeholder]="'SystemAdmin.Components.Chat.SearchConversations' | translate" />
            </div>

            <div class="chat-popup__list">
                <ng-container *ngIf="!listLoading; else loadingConversations">
                    <button *ngFor="let conversation of filteredConversations" class="chat-popup__list-item"
                        [class.active]="activeConversation?.id === conversation.id"
                        [class.menu-open]="openConversationMenuId === conversation.id"
                        (click)="selectConversation(conversation)">
                        <div class="chat-popup__list-item-content">
                            <div class="chat-popup__avatar"
                                [class.ai-avatar]="conversation.type === ChatConversationType.Ai">
                                <img *ngIf="conversation.type !== ChatConversationType.Ai"
                                    [src]="getOtherMemberAvatarUrl(conversation)" alt=""
                                    (error)="onAvatarError($event)" />
                                <!-- AI Sabit Avatar - Sihirli gradient -->
                                <div *ngIf="conversation.type === ChatConversationType.Ai" class="ai-avatar-icon">
                                    <svg class="ai-avatar-icon__glyph" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="chat-popup__list-meta">
                                <div class="chat-popup__list-title">{{ getConversationTitle(conversation) }}</div>
                                <div class="chat-popup__list-preview" *ngIf="conversation.lastMessagePreview">
                                    {{ conversation.lastMessagePreview | slice:0:25 }}{{
                                    conversation.lastMessagePreview.length > 25 ? '...' : '' }}
                                </div>
                            </div>
                        </div>
                        <div class="chat-popup__list-actions">
                            <span class="chat-popup__list-badge"
                                *ngIf="conversation.unreadCount && conversation.unreadCount > 0">
                                {{ conversation.unreadCount }}
                            </span>
                            <button class="chat-popup__list-menu-button"
                                (click)="toggleConversationMenu(conversation, $event)">
                                ⋮
                            </button>
                            <div class="chat-popup__list-menu" *ngIf="openConversationMenuId === conversation.id">
                                <button class="chat-popup__list-menu-item"
                                    (click)="deleteConversation(conversation, $event)">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2">
                                        <path
                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                    {{ 'SystemAdmin.Components.Chat.Delete' | translate }}
                                </button>
                            </div>
                        </div>
                    </button>
                </ng-container>
                <ng-template #loadingConversations>
                    <div class="chat-popup__list-loading">{{ 'SystemAdmin.Common.Loading' | translate }}...</div>
                </ng-template>
            </div>
        </aside>

        <!-- Chat Area -->
        <section class="chat-popup__body" role="region" aria-label="Chat conversation">
            <!-- Messages Loading Indicator -->
            <div class="chat-popup__messages-loading" *ngIf="messagesLoading">
                <div class="chat-popup__messages-loading-card">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        class="animate-spin">
                        <circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-dashoffset="20" />
                    </svg>
                    {{ 'SystemAdmin.Components.Chat.LoadingMessages' | translate }}
                </div>
            </div>

            <!-- Messages -->
            <div class="chat-popup__messages" #messagesContainer>
                <ng-container *ngIf="messages.length > 0; else emptyState">
                    <div *ngFor="let message of messages" class="chat-message"
                        [class.chat-message--own]="message.author?.id === currentUser?.id"
                        [class.chat-message--ai]="message.author?.id === aiUser?.id"
                        [class.chat-message--card]="!!message.card"
                        [class.chat-message--system]="message.author?.id === systemUser?.id">

                        <!-- Avatar -->
                        <div class="chat-message__avatar" *ngIf="message.author?.id !== systemUser?.id">
                            <!-- AI Sabit Avatar - Sihirli gradient -->
                            <div *ngIf="message.author?.id === aiUser?.id" class="ai-avatar-icon">
                                <svg class="ai-avatar-icon__glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                </svg>
                            </div>
                            <img *ngIf="message.author?.id !== aiUser?.id && message.author?.avatarUrl"
                                [src]="message.author.avatarUrl" alt="" />
                            <span *ngIf="!message.author?.avatarUrl && message.author?.id !== aiUser?.id">👤</span>
                        </div>

                        <!-- Content -->
                        <div class="chat-message__content">
                            <div class="chat-message__author"
                                *ngIf="message.author?.id !== currentUser?.id && message.author?.id !== systemUser?.id">
                                {{ message.author?.name }}
                            </div>
                            <!-- Standard text bubble -->
                            <div class="chat-message__bubble" *ngIf="message.text" [innerHTML]="message.text | chatMarkdown"></div>

                            <!-- Nawizard card bubble(s) -->
                            <div class="chat-message__bubble chat-message__bubble--card"
                                *ngIf="message.card?.kind === 'nawizard.card.user_profile'">
                                <app-nawizard-user-profile-card
                                    [personId]="message.card.data.personId"
                                    [displayName]="message.card.data.displayName">
                                </app-nawizard-user-profile-card>
                            </div>
                            <div class="chat-message__meta">
                                <span>{{ message.timestamp | date:'shortTime' }}</span>
                                <span class="chat-message__edited" *ngIf="message.isEdited">{{
                                    'SystemAdmin.Components.Chat.Edited' | translate }}</span>
                            </div>

                            <!-- AI Actions -->
                            <div class="chat-message__actions" *ngIf="message.author?.id === aiUser?.id && !message.card">
                                <button class="chat-message__action-btn"
                                    [title]="'SystemAdmin.Components.Chat.Copy' | translate"
                                    (click)="copyMessage(message.rawText)">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                        <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                                    </svg>
                                    {{ 'SystemAdmin.Components.Chat.Copy' | translate }}
                                </button>
                                <button class="chat-message__action-btn"
                                    [title]="'SystemAdmin.Components.Chat.Regenerate' | translate"
                                    (click)="regenerateMessage(message)">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2">
                                        <path
                                            d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
                                    </svg>
                                    {{ 'SystemAdmin.Components.Chat.Regenerate' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- iOS Typing Indicator - AI -->
                    <div class="chat-message chat-message--typing" *ngIf="isAiTyping">
                        <div class="chat-message__avatar ai-avatar">
                            <div class="ai-avatar-icon">
                                <svg class="ai-avatar-icon__glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                </svg>
                            </div>
                        </div>
                        <div class="chat-message__content">
                            <div class="chat-message__bubble">
                                <div class="typing-indicator">
                                    <div class="typing-indicator__dot"></div>
                                    <div class="typing-indicator__dot"></div>
                                    <div class="typing-indicator__dot"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- iOS Typing Indicator - Remote User -->
                    <div class="chat-message chat-message--typing" *ngIf="isRemoteTyping && !isAiTyping">
                        <div class="chat-message__avatar">
                            <span>👤</span>
                        </div>
                        <div class="chat-message__content">
                            <div class="chat-message__bubble">
                                <div class="typing-indicator">
                                    <div class="typing-indicator__dot"></div>
                                    <div class="typing-indicator__dot"></div>
                                    <div class="typing-indicator__dot"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-template #emptyState>
                    <div class="chat-popup__empty">
                        <div class="chat-popup__empty-icon">💬</div>
                        <div class="chat-popup__empty-title">{{ 'SystemAdmin.Components.Chat.NoMessages' | translate }}
                        </div>
                        <div class="chat-popup__empty-text">{{ 'SystemAdmin.Components.Chat.StartConversation' |
                            translate }}</div>
                    </div>
                </ng-template>
            </div>

            <!-- AI Suggestions -->
            <div class="chat-popup__suggestions"
                *ngIf="activeConversation?.type === ChatConversationType.Ai && aiSuggestions.length > 0">
                <button *ngFor="let suggestion of aiSuggestions" class="chat-popup__suggestion"
                    (click)="sendMessage(suggestion)">
                    {{ suggestion }}
                </button>
            </div>

            <!-- Input Area -->
            <div class="chat-popup__input-area">
                <div class="chat-popup__input-wrapper">
                    <textarea class="chat-popup__input" [(ngModel)]="messageInput"
                        [placeholder]="'SystemAdmin.Components.Chat.TypeMessage' | translate" rows="1"
                        (input)="onMessageInput()" (keydown.enter)="onEnterKey($event)" #messageInputEl></textarea>
                    <div class="chat-popup__input-actions">
                        <button class="chat-popup__input-btn" [title]="'SystemAdmin.Components.Chat.Emoji' | translate"
                            (click)="toggleEmojiPicker($event)">
                            😊
                        </button>
                        <button class="chat-popup__input-btn send"
                            [title]="'SystemAdmin.Components.Chat.Send' | translate"
                            [disabled]="!messageInput?.trim() || !activeConversation" (click)="sendMessage()">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Emoji Picker -->
            <div class="chat-popup__emoji-picker" *ngIf="showEmojiPicker" (click)="$event.stopPropagation()">
                <input type="text" class="chat-popup__emoji-search" [(ngModel)]="emojiQuery"
                    [placeholder]="'SystemAdmin.Components.Chat.SearchEmoji' | translate" />
                <div class="chat-popup__emoji-categories">
                    <button *ngFor="let cat of emojiCategories" class="chat-popup__emoji-category"
                        [class.active]="activeEmojiCategory === cat.id" (click)="setEmojiCategory(cat.id)">
                        {{ cat.label }}
                    </button>
                </div>
                <div class="chat-popup__emoji-grid">
                    <div *ngFor="let emoji of filteredEmojis" class="chat-popup__emoji-item"
                        (click)="sendEmoji(emoji, $event)">
                        {{ emoji }}
                    </div>
                </div>
            </div>
        </section>
    </div>

    <!-- User Picker Modal -->
    <div class="chat-popup__user-picker-overlay" *ngIf="showUserPicker" (click)="closeUserPicker()">
        <div class="chat-popup__user-picker" (click)="$event.stopPropagation()">
            <div class="chat-popup__user-picker-header">
                <span class="chat-popup__user-picker-title">{{ 'SystemAdmin.Components.Chat.NewChat' | translate
                    }}</span>
                <button class="chat-popup__user-picker-close" (click)="closeUserPicker()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <input type="text" class="chat-popup__user-picker-search" [(ngModel)]="userQuery"
                (input)="onUserQueryChanged()" [placeholder]="'SystemAdmin.Components.Chat.SearchUsers' | translate" />
            <div class="chat-popup__user-list">
                <ng-container *ngIf="!listLoading; else loadingUsers">
                    <button *ngFor="let user of filteredUsers" class="chat-popup__user-item"
                        [class.chat-popup__user-item--ai]="isAiUser(user.id)"
                        (click)="isAiUser(user.id) ? startAiChat(user) : startDirectChat(user)">
                        <!-- AI kullanıcısı için sihirli gradient avatar -->
                        <div *ngIf="isAiUser(user.id); else normalAvatar" class="ai-avatar-icon ai-avatar-icon--small">
                            <svg class="ai-avatar-icon__glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                            </svg>
                        </div>
                        <ng-template #normalAvatar>
                            <img [src]="getUserAvatarUrl(user)" alt="" (error)="onUserAvatarError($event)" />
                        </ng-template>
                        <span class="chat-popup__user-item-name">{{ user.name }}</span>
                    </button>
                </ng-container>
                <ng-template #loadingUsers>
                    <div class="chat-popup__list-loading">{{ 'SystemAdmin.Common.Loading' | translate }}...</div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
